import Polyglot from 'node-polyglot';
import * as notifications from 'src/common/notification';

import { showAlert, showConfirm, showMultipleConfirm } from '../components/show-modal';
import { addGlobal, createGUID } from '../utils';
import * as account from './account';
import {
  AutoCompleteDataItem,
  doesListContainLabelValuePair,
  listAbovePosition,
  listBelowPosition,
  setAutoCompleteSourceData,
  setNameAndValueInputs,
  setupAutocomplete,
  setupAutocompleteInternal,
} from './autocomplete';
import {
  assignAutoDate,
  ButtonKeys,
  cellWrappingLast,
  centerMask,
  clearGrid,
  dateChangedHandler,
  endsWith,
  loadSeahorseDataShared,
  RedirectToLogin,
  removeValidationFromField,
  setupBlockUIDefaults,
  toTitleCase,
} from './common';
import { documentFrameDocument } from './dom-utils';
import { FancyboxBuilder, setFancyIFrameCloseButtonShow, setupProgress, Utils } from './fancybox';
import * as validation from './validation-extensions';

window.Polyglot = Polyglot;

addGlobal('common', {
  account,
  assignAutoDate,
  AutoCompleteDataItem,
  ButtonKeys,
  cellWrappingLast,
  centerMask,
  clearGrid,
  createGUID,
  dateChangedHandler,
  documentFrameDocument,
  doesListContainLabelValuePair,
  endsWith,
  listAbovePosition,
  listBelowPosition,
  loadSeahorseDataShared,
  RedirectToLogin,
  removeValidationFromField,
  setAutoCompleteSourceData,
  setNameAndValueInputs,
  setupAutocomplete,
  setupAutocompleteInternal,
  setupBlockUIDefaults,
  showAlert,
  showConfirm,
  showMultipleConfirm,
  notifications,
  toTitleCase,
});

addGlobal('fancybox', {
  FancyboxBuilder,
  setFancyIFrameCloseButtonShow,
  setupProgress,
  Utils: Utils.getInstance,
});

validation.init();
